<template>
    <MfaCodeAuthentication
        method="email"
        :auto-send="autoSend"
    />
</template>

<script>
import MfaCodeAuthentication from './MfaCodeAuthentication.vue'

export default {
    components: {
        MfaCodeAuthentication,
    },
    props: {
        autoSend: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
